import { CONTENT_LOCALES } from './content-i18n/constants';
import { CONTENT_TYPE } from 'utils/constants';

const constructUserInfo = (user, isLessonPlannerEnabled) => {
  return {
    username: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    signUpAt: user.createdAt,
    role: user.userType,
    props: {
      userId: user._id,
      isDemo: user.isDemo,
      organizationId: user.organizationId,
      organizationCode: user.organization.code,
      organizationType: user.organization.type,
      commsLanguage: user.organization.settings.welcomeEmailLanguage,
      isOneOnOneEnabled: user.organization.settings.visibleContentTypesForUser.includes(
        CONTENT_TYPE.topic
      ),
      preferredLocale: user.preferredLocale,
      isLessonPlannerEnabled,
    },
  };
};

const PRODUCT_FRUITS_DISPLAY_LANGUAGE = Object.freeze({
  english: 'en',
  traditionalChinese: 'zh',
  simplifiedChinese: 'ja',
});

const DISPLAY_LANGUAGE_MAP_BY_LOCALE = Object.freeze({
  [CONTENT_LOCALES.zhCN.code]: PRODUCT_FRUITS_DISPLAY_LANGUAGE.simplifiedChinese,
  [CONTENT_LOCALES.zhHK.code]: PRODUCT_FRUITS_DISPLAY_LANGUAGE.traditionalChinese,
  [CONTENT_LOCALES.enGB.code]: PRODUCT_FRUITS_DISPLAY_LANGUAGE.english,
  [CONTENT_LOCALES.enUS.code]: PRODUCT_FRUITS_DISPLAY_LANGUAGE.english,
});

export const initializeProductFruits = (window, user, esfDemoFF) => {
  if (!user?._id || !!esfDemoFF.isLoading) return;
  window.dataLayer.push({
    productFruitsUserInfo: constructUserInfo(user, esfDemoFF.isEnabled),
    productFruitsDisplayLanguage: DISPLAY_LANGUAGE_MAP_BY_LOCALE[user.preferredLocale],
  });

  window.dataLayer.push({ event: 'product-fruits-user-info-set' });
};
